module.exports = __webpack_public_path__ + "static/zp-bold-6c7b5fc65a96aea76a414bf336f4a7a7.otf";